import React from 'react'

type Action =
  | {
      type: 'DRAWER_OPEN'
    }
  | {
      type: 'DRAWER_CLOSE'
    }
type Dispatch = (action: Action) => void
type State = {
  drawerOpen: boolean
}
type NavDrawerProviderProps = { children: React.ReactNode }

const NavDrawerContext = React.createContext<
  { state: State; dispatch: Dispatch } | undefined
>(undefined)

const navDrawerReducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'DRAWER_OPEN': {
      state.drawerOpen = true
      return {
        ...state,
      }
    }
    case 'DRAWER_CLOSE': {
      state.drawerOpen = false
      return {
        ...state,
      }
    }
  }
}

const NavDrawerProvider = ({ children }: NavDrawerProviderProps) => {
  const [state, dispatch] = React.useReducer(navDrawerReducer, {
    drawerOpen: false,
  })
  const value = { state, dispatch }
  return (
    <NavDrawerContext.Provider value={value}>
      {children}
    </NavDrawerContext.Provider>
  )
}

const useNavDrawer = () => {
  const context = React.useContext(NavDrawerContext)
  if (context === undefined) {
    throw new Error('useNavDrawer must be used within a NavDrawerProvider')
  }
  return context
}

export { NavDrawerProvider, useNavDrawer }
